import { isEmptyObject } from "../../../utils/tests";
import { ScorersRankingPlayerPageQuery } from '../types';

/**
 * typeguard for ScorersRankingPlayerPageQuery
 * @param ScorersRankingPlayerPageQuery object passed to transformer
 */
export const isValidScorersRankingPlayerPage = (obj: ScorersRankingPlayerPageQuery): boolean => Boolean(obj?.data?.getScorersRankingPlayerPage && !isEmptyObject(obj.data.getScorersRankingPlayerPage));
